import React from "react";

const DownloadIcon = (props) => {
  const { size } = props;
  return (
    <>
      <div className="dropdown">
        <a
          className="btn cert-icon btn-transparent-dark dropdown-toggle position-static noArrow  pr-1"
          data-bs-toggle="dropdown"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            width={size}
            viewBox="0 -960 960 960"
            fill="#000000"
          >
            <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
          </svg>
        </a>
        <div
          className="dropdown-menu dropdown-menu shadow"
          aria-labelledby="userDropdown"
        >
          {props.iconDropDownList?.map((list, listIndex) => {
            const { label, clickHandler } = list;
            return (
              <div
                className="dropdown-item"
                key={listIndex}
                onClick={clickHandler}
                title={label}
              >
                {label}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
DownloadIcon.defaultProps = {
  size: 22,
};
export default DownloadIcon;
